"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var store = require('../../../../../../../app_adyen_SFRA/cartridge/config/store')

var helpers = require('../checkout/helpers');
var constants = require('../../../../../config/constants');
var customAdyenCode = require('./customAdyenCode');
function getFallback(paymentMethod) {
  var fallback = {};
  if (fallback[paymentMethod.type]) {
    store.componentsObj[paymentMethod.type] = {};
  }
  return fallback[paymentMethod.type];
}
function getPersonalDetails() {
  var _document$querySelect, _document$querySelect2, _document$querySelect3, _document$querySelect4;
  return {
    firstName: (_document$querySelect = document.querySelector('#shippingFirstNamedefault')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value,
    lastName: (_document$querySelect2 = document.querySelector('#shippingLastNamedefault')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.value,
    telephoneNumber: (_document$querySelect3 = document.querySelector('#shippingPhoneNumberdefault')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.value,
    shopperEmail: (_document$querySelect4 = document.querySelector('.customer-summary-email')) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.textContent
  };
}
var getComponentConfig = function getComponentConfig(paymentMethodID, paymentMethod) {
  var baseConfig = {
    data: {
      personalDetails: getPersonalDetails()
    },
    visibility: {
      personalDetails: 'editable',
      billingAddress: 'hidden',
      deliveryAddress: 'hidden'
    }
  };
  var additionalConfig = paymentMethodID.includes('storedCard') ? _objectSpread(_objectSpread({}, store.paymentMethodsConfiguration.storedCard), paymentMethod) : store.paymentMethodsConfiguration[paymentMethodID];
  return _objectSpread(_objectSpread({}, baseConfig), additionalConfig);
};
function checkIfNodeIsAvailable(_x) {
  return _checkIfNodeIsAvailable.apply(this, arguments);
}
function _checkIfNodeIsAvailable() {
  _checkIfNodeIsAvailable = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(node) {
    var isNodeAvailable;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(typeof node.isAvailable === 'function')) {
            _context2.next = 11;
            break;
          }
          _context2.prev = 1;
          _context2.next = 4;
          return node.isAvailable();
        case 4:
          isNodeAvailable = _context2.sent;
          return _context2.abrupt("return", isNodeAvailable);
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](1);
          return _context2.abrupt("return", false);
        case 11:
          return _context2.abrupt("return", true);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return _checkIfNodeIsAvailable.apply(this, arguments);
}
function setNode(_x2, _x3) {
  return _setNode.apply(this, arguments);
}
function _setNode() {
  _setNode = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(paymentMethod, paymentMethodID) {
    var componentConfig, node, isAvailable;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!store.componentsObj[paymentMethodID]) {
            store.componentsObj[paymentMethodID] = {};
          }
          componentConfig = getComponentConfig(paymentMethodID, paymentMethod);
          node = window.AdyenWeb.createComponent(paymentMethod.type, store.checkout, componentConfig);
          _context3.next = 5;
          return checkIfNodeIsAvailable(node);
        case 5:
          isAvailable = _context3.sent;
          store.componentsObj[paymentMethodID].node = node;
          store.componentsObj[paymentMethodID].isValid = node.isValid;
          store.componentsObj[paymentMethodID].isAvailable = isAvailable;
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _setNode.apply(this, arguments);
}
function getPaymentMethodID(isStored, paymentMethod) {
  if (isStored) {
    return "storedCard".concat(paymentMethod.id);
  }
  if (paymentMethod.type === constants.GIFTCARD) {
    return constants.GIFTCARD;
  }
  if (paymentMethod.brand) {
    return "".concat(paymentMethod.type, "_").concat(paymentMethod.brand);
  }
  return paymentMethod.type;
}
function isShippingStage() {
  var checkoutMain = document.getElementById('checkout-main');
  var dataStage = checkoutMain === null || checkoutMain === void 0 ? void 0 : checkoutMain.dataset.checkoutStage;
  var urlParams = new URLSearchParams(window.location.search);
  var urlStage = urlParams.get('stage');
  var hash = window.location.hash;
  return dataStage === 'shipping' || urlStage === 'shipping' || hash === '#shipping';
}

function shouldSkipPaymentsOnShipping(paymentMethod) {
  return isShippingStage();
}
function getImage(isStored, paymentMethod) {
  return isStored ? paymentMethod.brand : paymentMethod.type;
}
function getLabel(isStored, paymentMethod) {
  var label = isStored ? ' '.concat(store.MASKED_CC_PREFIX).concat(paymentMethod.lastFour) : '';
    if (paymentMethod.type === 'scheme' && !isStored) {
        return '(Visa, Mastercard, American Express, Discover)'.concat(label);
    } else if (paymentMethod.type === 'giftcard') {
        return 'Gift Card';
    }
    if (paymentMethod.type === 'scheme' && isStored) {
      if (paymentMethod.name === 'American Express') {
        paymentMethod.name = '<span class="savedcard-icon"><svg class="paymentMethodIcon"><use xlink:href="#new-amex-card"></use></svg></span>';
      } else if (paymentMethod.name === 'Discover') {
        paymentMethod.name = '<span class="savedcard-icon"><svg class="paymentMethodIcon"><use xlink:href="#new-discover-card"></use></svg></span>';
      } else if (paymentMethod.name === 'Diners Club') {
        paymentMethod.name = '<span class="savedcard-icon"><svg class="paymentMethodIcon"><use xlink:href="#new-dining-card"></use></svg></span>';
      } else if (paymentMethod.name === 'JCB') {
        paymentMethod.name = '<span class="savedcard-icon"><svg class="paymentMethodIcon"><use xlink:href="#new-jcb-card"></use></svg></span>';
      } else if (paymentMethod.name === 'MasterCard') {
        paymentMethod.name = '<span class="savedcard-icon"><svg class="paymentMethodIcon"><use xlink:href="#new-master-card"></use></svg></span>';
      } else if (paymentMethod.name === 'VISA') {
        paymentMethod.name = '<span class="savedcard-icon"><svg class="paymentMethodIcon"><use xlink:href="#new-visa-card"></use></svg></span>';
      } else {
        paymentMethod.name = paymentMethod.name;
      }
    }
    return paymentMethod.type === 'scheme' ? ''.concat(label + ' ').concat(' ' + paymentMethod.name): ''.concat(label).concat(paymentMethod.name);
}
function handleFallbackPayment(_x4) {
  return _handleFallbackPayment.apply(this, arguments);
}
function _handleFallbackPayment() {
  _handleFallbackPayment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref) {
    var paymentMethod, container, paymentMethodID, fallback, createTemplate;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          paymentMethod = _ref.paymentMethod, container = _ref.container, paymentMethodID = _ref.paymentMethodID;
          fallback = getFallback(paymentMethod);
          createTemplate = function createTemplate() {
            var template = document.createElement('template');
            template.innerHTML = fallback;
            container.append(template.content);
          };
          return _context4.abrupt("return", fallback ? createTemplate() : setNode(paymentMethod, paymentMethodID));
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _handleFallbackPayment.apply(this, arguments);
}
function handlePayment(_x5) {
  return _handlePayment.apply(this, arguments);
}
function _handlePayment() {
  _handlePayment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(options) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", options.isStored ? setNode(options.paymentMethod, options.paymentMethodID) : handleFallbackPayment(options));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _handlePayment.apply(this, arguments);
}
function getListContents(_ref2) {
  var imagePath = _ref2.imagePath,
    isStored = _ref2.isStored,
    paymentMethod = _ref2.paymentMethod,
    description = _ref2.description;

    //AdyenUpgrade24.1.0 - Added new function (generateLiContent) to generate list content
    description = '';
    var paymentMethodID = getPaymentMethodID(isStored, paymentMethod);
    var label = getLabel(isStored, paymentMethod);
    var liContents = customAdyenCode.generateLiContent(paymentMethodID, paymentMethod , label, isStored);
    return description ? ''.concat(liContents, '<p>').concat(description, '</p>') : liContents;
}
function getImagePath(_ref3) {
  var isStored = _ref3.isStored,
    paymentMethod = _ref3.paymentMethod,
    path = _ref3.path,
    isSchemeNotStored = _ref3.isSchemeNotStored;
  var paymentMethodImage = "".concat(path).concat(getImage(isStored, paymentMethod), ".png");
  var cardImage = "".concat(path, "card.png");
  return isSchemeNotStored ? cardImage : paymentMethodImage;
}
function setValid(_ref4) {
  var isStored = _ref4.isStored,
    paymentMethodID = _ref4.paymentMethodID,
    paymentMethod = _ref4.paymentMethod;
  if (isStored && ['bcmc', 'scheme'].indexOf(paymentMethod.type) > -1) {
    store.componentsObj[paymentMethodID].isValid = true;
  }
}
function configureContainer(_ref5) {
  var paymentMethodID = _ref5.paymentMethodID,
    container = _ref5.container;
  container.classList.add('additionalFields');
  container.setAttribute('id', "component_".concat(paymentMethodID));
  container.setAttribute('style', 'display:none');
}
function handleInput(_ref6) {
  var paymentMethodID = _ref6.paymentMethodID;
  var input = document.querySelector("#rb_".concat(paymentMethodID));
  if (input) {
    input.onchange = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              //AdyenUpgrade24.1.0 - Added custom code to show/hide address form on input change
              customAdyenCode.handleAddressUpdateOnInputChange(event);
              helpers.displaySelectedMethod(event.target.value);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }();
  }
}

function createListItem(paymentMethodID, liContents) {
  var li = document.createElement('li');
  li.innerHTML = liContents;
  li.classList.add('paymentMethod');
  return li;
}
function mountComponentIfAvailable(paymentMethodID, container, li) {
  var componentObj = store.componentsObj[paymentMethodID];
  var isAvailable = componentObj === null || componentObj === void 0 ? void 0 : componentObj.isAvailable;
  if (isAvailable !== false) {
    var _componentObj$node;
    componentObj === null || componentObj === void 0 ? void 0 : (_componentObj$node = componentObj.node) === null || _componentObj$node === void 0 ? void 0 : _componentObj$node.mount(container);
    return true;
  }
  li.remove();
  delete store.componentsObj[paymentMethodID];
  return false;
}

/**
 * To avoid re-rendering components twice, unmounts existing components from payment methods list
 */
function clearPaymentMethodsContainer() {
  var paymentMethodContainer = document.querySelector('#paymentMethodsList');
  // unmount all components before clearing
  Object.keys(store.componentsObj).forEach(function (paymentMethodID) {
    var component = store.componentsObj[paymentMethodID];
    if (component !== null && component !== void 0 && component.node) {
      try {
        component.node.unmount();
      } catch (unmountError) {
        //
      }
    }
  });
  paymentMethodContainer.innerHTML = '';
  store.clearPaymentMethod();
}
function renderPaymentMethod(_x7, _x8, _x9) {
  return _renderPaymentMethod.apply(this, arguments);
}
/**
 * Renders the retrieved payment methods excluding gift cards (including card component)
 */
function _renderPaymentMethod() {
  _renderPaymentMethod = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(paymentMethod, isStored, path) {
    var description,
      paymentMethodTitle,
      canRender,
      paymentMethodsUI,
      paymentMethodID,
      isSchemeNotStored,
      _container,
      options,
      imagePath,
      liContents,
      li,
      _args6 = arguments;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          description = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : null;
          paymentMethodTitle = _args6.length > 4 && _args6[4] !== undefined ? _args6[4] : null;
          _context6.prev = 2;
          paymentMethodsUI = document.querySelector('#paymentMethodsList');
          paymentMethodID = getPaymentMethodID(isStored, paymentMethod);
          _context6.next = 7;
          break;
        case 7:
          isSchemeNotStored = paymentMethod.type === 'scheme' && !isStored;
          _container = document.createElement('div');
          options = {
            container: _container,
            paymentMethod: paymentMethod,
            isStored: isStored,
            path: path,
            description: description,
            paymentMethodID: paymentMethodID,
            paymentMethodTitle: paymentMethodTitle,
            isSchemeNotStored: isSchemeNotStored
          };
          imagePath = getImagePath(options);
          liContents = getListContents(_objectSpread(_objectSpread({}, options), {}, {
            imagePath: imagePath,
            description: description
          }));
          li = createListItem(paymentMethodID, liContents);
          _context6.next = 15;
          return handlePayment(options);
        case 15:
          if ($(li).find('#rb_applepay').length) {
            //AdyenUpgrade24.1.0 -  Adding class to hide apple pay in other browser
              li.classList.add('applePay-list');
          }
      
          if ($(li).find('#rb_giftcard').length) {
              //AdyenUpgrade24.1.0 - Adding class to hide gift card paymeny type 
              li.classList.add('giftcard-list');
          }
          configureContainer(options);
          li.append(_container);
          paymentMethodsUI.append(li);
          //AdyenUpgrade24.1.0 - Adding address form container for credit card and stored cards
          var billingContainer;
          if (paymentMethod.type === 'scheme' && !isStored) {
              billingContainer = document.createElement('div');
              billingContainer.classList.add('payment-billing-cc');
              li.append(billingContainer);
          } else if (paymentMethod.type === 'scheme' && isStored) {
              billingContainer = document.createElement('div');
              billingContainer.classList.add('payment-billing-saved-cc');
              li.append(billingContainer);
          }
          mountComponentIfAvailable(paymentMethodID, _container, li);
          if (paymentMethodID === constants.GIROPAY) {
            _container.innerHTML = '';
          }
          handleInput(options);
          setValid(options);
          canRender = true;
          _context6.next = 28;
          break;
        case 25:
          _context6.prev = 25;
          _context6.t0 = _context6["catch"](2);
          canRender = false;
        case 28:
          return _context6.abrupt("return", canRender);
        case 29:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[2, 25]]);
  }));
  return _renderPaymentMethod.apply(this, arguments);
}
function renderCheckout(_x0) {
  return _renderCheckout.apply(this, arguments);
}
function _renderCheckout() {
  _renderCheckout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(paymentMethodsResponse) {
    var _paymentMethodsRespon, paymentMethods, storedPaymentMethods, imagePath, adyenDescriptions, adyenPaymentMethodTitles, locale, filteredPaymentMethods, renderStoredPaymentMethods, renderPaymentMethods;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _paymentMethodsRespon = paymentMethodsResponse.AdyenPaymentMethods, paymentMethods = _paymentMethodsRespon.paymentMethods, storedPaymentMethods = _paymentMethodsRespon.storedPaymentMethods, imagePath = paymentMethodsResponse.imagePath, adyenDescriptions = paymentMethodsResponse.adyenDescriptions, adyenPaymentMethodTitles = paymentMethodsResponse.adyenPaymentMethodTitles, locale = paymentMethodsResponse.locale;
          clearPaymentMethodsContainer();
          filteredPaymentMethods = paymentMethods.filter(function (pm) {
            var _store$fastlane$authR;
            if (shouldSkipPaymentsOnShipping(pm)) {
              return false;
            }
            return !(pm.type === constants.FASTLANE && ((_store$fastlane$authR = store.fastlane.authResult) === null || _store$fastlane$authR === void 0 ? void 0 : _store$fastlane$authR.authenticationState) !== 'succeeded');
          });
          renderStoredPaymentMethods = storedPaymentMethods.map(function (pm) {
            var _adyenPaymentMethodTi;
            return renderPaymentMethod(pm, true, imagePath, adyenDescriptions === null || adyenDescriptions === void 0 ? void 0 : adyenDescriptions[pm.type], adyenPaymentMethodTitles === null || adyenPaymentMethodTitles === void 0 ? void 0 : (_adyenPaymentMethodTi = adyenPaymentMethodTitles[locale]) === null || _adyenPaymentMethodTi === void 0 ? void 0 : _adyenPaymentMethodTi[pm.type]);
          });
          renderPaymentMethods = filteredPaymentMethods.map(function (pm) {
            var _adyenPaymentMethodTi2;
            return renderPaymentMethod(pm, false, imagePath, adyenDescriptions === null || adyenDescriptions === void 0 ? void 0 : adyenDescriptions[pm.type], adyenPaymentMethodTitles === null || adyenPaymentMethodTitles === void 0 ? void 0 : (_adyenPaymentMethodTi2 = adyenPaymentMethodTitles[locale]) === null || _adyenPaymentMethodTi2 === void 0 ? void 0 : _adyenPaymentMethodTi2[pm.type]);
          });
          _context7.next = 7;
          return Promise.all([].concat(_toConsumableArray(renderStoredPaymentMethods), _toConsumableArray(renderPaymentMethods)));
        case 7:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _renderCheckout.apply(this, arguments);
}
customAdyenCode.klarnaButtonSubmit();
customAdyenCode.afterPaySubmitButton();
customAdyenCode.applePaySubmitButton();
module.exports = {
  renderCheckout: renderCheckout,
  renderPaymentMethod: renderPaymentMethod
};